const CHUNK_RELOAD_KEY = "tema_chunk_reload";

function isChunkLoadError(error) {
  return (
    error?.name === "ChunkLoadError" ||
    /Loading chunk [\w.-]+ failed/i.test(String(error?.message ?? ""))
  );
}

/**
 * Recover from stale lazy chunks after a dev-server rebuild (one automatic reload).
 */
export function loadWithChunkRetry(loadFn) {
  return loadFn().catch((error) => {
    if (
      isChunkLoadError(error) &&
      typeof window !== "undefined" &&
      !sessionStorage.getItem(CHUNK_RELOAD_KEY)
    ) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
      return new Promise(() => {});
    }

    if (typeof window !== "undefined") {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    }

    throw error;
  });
}

export function clearChunkReloadFlag() {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  }
}
